module.exports = __webpack_public_path__ + "static/media/edit.0ab4c517.svg";